import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';

/** /voucha-team: moderators/admins only. List of the accounts Voucha runs. */
export default class DirectoryPage extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    app.setTitle('Voucha Team accounts');
    this.accounts = null;
    this.denied = !app.forum.attribute('vouchaTeamDirectory');
    if (this.denied) return;
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/voucha-engagement/directory'
    }).then(r => this.accounts = r.accounts || []).catch(() => this.accounts = []).finally(() => m.redraw());
  }
  view() {
    if (this.denied) {
      return m("div", {
        className: "VECDir container"
      }, m("p", {
        className: "VECDir-muted"
      }, "This page is only available to moderators."));
    }
    return m("div", {
      className: "VECDir container"
    }, m("header", {
      className: "VECDir-head"
    }, m("h1", null, m("i", {
      className: "fas fa-id-badge",
      "aria-hidden": "true"
    }), " Voucha Team accounts"), m("p", null, "These accounts are run by Voucha to start conversations and keep discussions going. Their posts may be written with AI assistance and are reviewed by our team before they're published. Every post from them carries the ", m("strong", null, "Voucha Team"), " label. Their profiles describe the perspective each account writes from; they're not personal accounts of real individuals.")), !this.accounts ? m(LoadingIndicator, null) : this.accounts.length ? m("ul", {
      className: "VECDir-list"
    }, this.accounts.map(a => m("li", {
      className: "VECDir-card"
    }, m("a", {
      className: "VECDir-who",
      href: app.route('user', {
        username: a.username
      })
    }, a.avatarUrl ? m("img", {
      className: "VECDir-avatar",
      src: a.avatarUrl,
      alt: ""
    }) : m("span", {
      className: "VECDir-avatar"
    }, (a.displayName || a.username).charAt(0).toUpperCase()), m("span", null, m("strong", null, a.displayName), m("span", {
      className: "VECDir-muted"
    }, "@", a.username))), m("div", {
      className: "VECDir-meta"
    }, [a.profession, a.location ? 'Lives in ' + a.location : null, a.origin ? 'From ' + a.origin : null, a.study ? 'Studied ' + a.study : null].filter(Boolean).join(' · ')), a.bio ? m("p", {
      className: "VECDir-bio"
    }, a.bio) : null, a.interests && a.interests.length ? m("div", {
      className: "VECDir-interests"
    }, a.interests.map(i => m("span", null, i))) : null, m("div", {
      className: "VECDir-flags"
    }, m("span", null, m("i", {
      className: "fas fa-id-badge",
      "aria-hidden": "true"
    }), " Voucha-managed"), m("span", null, m("i", {
      className: "fas fa-robot",
      "aria-hidden": "true"
    }), " May use AI-assisted writing"))))) : m("p", {
      className: "VECDir-muted"
    }, "No Voucha Team accounts at the moment."));
  }
}